import React, { useState } from "react";
import { Modal, Button, Typography, Spin, Icon } from "antd";
import { isEmpty } from "../../common/Common";

const { Title, Paragraph, Text } = Typography;

const WarningModal = (props) => {
  const { onCancel, onConfirm, warningMsg = "", isLoading = false, onCancelModal } = props;
  return (
    <Modal
      visible={true}
      onCancel={onCancelModal}
      footer={null}
      closable={true}
      maskClosable={false}
      className="warning-modal"
    >
      <Spin spinning={isLoading}>
        {/* <div className="modal-header">
          <div className="header-left">
            <Icon type="warning" className="warning-icon" />
            <div className="header-text">
              <Title level={4}>Critical Action</Title>
              <Text type="secondary">This action requires confirmation</Text>
            </div>
          </div>
        </div> */}

        <div className="modal-body">
          <div className="warning-section">
            <div className="trash-icon">
              <Icon type="delete" />
            </div>
            <div>
              <Title level={1}>Delete Orders</Title>
              <Paragraph>
                Are you sure you want to delete these orders? <br />
                This action cannot be undone.
              </Paragraph>{" "}
            </div>
          </div>

          {!isEmpty(warningMsg) && (
            <div className="security-notice">
              <Icon type="warning" className="security-icon" />
              <div>
                <Text strong>Warning Alert!!</Text>
                <Text type="warning">{warningMsg}</Text>
              </div>
            </div>
          )}

          <div className="action-buttons">
            <Button onClick={onCancel} disabled={isLoading} style={{borderRadius:"16px"}}>
              {isEmpty(warningMsg) ? "Cancel" : "No"}
            </Button>
            <Button
              type="primary"
              danger
              onClick={onConfirm}
              disabled={isLoading}
              icon={"delete"}
              style={{borderRadius:"16px"}}
            >
              {isEmpty(warningMsg) ? "Delete Orders" : "Yes"}
            </Button>
          </div>
        </div>
      </Spin>
    </Modal>
  );
};

export default WarningModal;